/* MindShift Studio — subtle motion + reveal observer */
(function () {
  if (typeof window === "undefined") return;

  // Reveal on scroll
  const els = document.querySelectorAll("[data-ms-reveal]");
  if ("IntersectionObserver" in window && els.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "60px 0px 60px 0px", threshold: 0 }
    );
    els.forEach((el) => io.observe(el));
  } else {
    els.forEach((el) => el.classList.add("is-in"));
  }

  // Hero parallax (very subtle)
  const heroes = document.querySelectorAll("[data-ms-parallax]");
  if (heroes.length && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          heroes.forEach((el) => {
            const rect = el.getBoundingClientRect();
            const offset = Math.max(-200, Math.min(200, rect.top * -0.08));
            el.style.setProperty("--ms-parallax-y", offset.toFixed(1) + "px");
          });
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }
})();
